import { useEffect } from "react";
import { Image, Link } from "components/base";
import { Container, ContainerFluid, Flex } from "components/base/container";
import { ArrowIcon } from "components/icon/icon.arrow";
import { useNavigate } from "react-router-dom";
import { useWallet } from "@manahippo/aptos-wallet-adapter";
import { MartianWalletName, PontemWalletName, AptosWalletName } from "@manahippo/aptos-wallet-adapter";
import { NormalBtn } from "components/element/element.button";

const WalletConnectPage = () => {
  const navigate = useNavigate();
  const { connected, select } = useWallet();
  useEffect(() => {
    if (connected) {
      navigate(-1);
    }
  }, [connected]);

  return (
    <ContainerFluid>
      <Container col pt={["60px", "60px", "80px", "100px"]} pb={["60px", "60px", "80px"]}>
        <Flex mx={"auto"} col>
          <Flex color={"white"} fontWeight={"600"} fontSize={["42px", "42px", "45px", "48px"]} lineHeight={"100%"}>
            Connect your wallet.
          </Flex>
          <Flex mt={"16px"} fontWeight={"400"} fontSize={"22px"} lineHeight={"100.5%"}>
            Connect with one of our available wallet providers or create a new one.
          </Flex>
          <Flex col gridGap={"12px"} mt={["48px", "48px", "73px", "98px"]}>
            <Flex
              alignCenter
              bg={"normal"}
              p={"10px 32px"}
              borderRadius={"6px"}
              cursor={"pointer"}
              onClick={() => {
                select(AptosWalletName);
              }}
            >
              <Flex bg={"light"} borderRadius={"8px"} justifyCenter alignCenter aspectRatio={"1"} width={"52px"}>
                <Image src={require("assets/image/wallet/petra.png")} width={"36px"} />
              </Flex>
              <Flex ml={["32px", "32px", "48px", "64px"]} color={"white"} fontWeight={"600"} fontSize={"28px"} lineHeight={"100%"}>
                Petra Wallet
              </Flex>
            </Flex>
            <Flex
              alignCenter
              bg={"normal"}
              p={"10px 32px"}
              borderRadius={"6px"}
              cursor={"pointer"}
              onClick={() => {
                select(PontemWalletName);
              }}
            >
              <Flex bg={"light"} borderRadius={"8px"} justifyCenter alignCenter aspectRatio={"1"} width={"52px"}>
                <Image src={require("assets/image/wallet/pontem.png")} width={"36px"} />
              </Flex>
              <Flex ml={["32px", "32px", "48px", "64px"]} color={"white"} fontWeight={"600"} fontSize={"28px"} lineHeight={"100%"}>
                Pontem Wallet
              </Flex>
            </Flex>
            <Flex
              alignCenter
              bg={"normal"}
              p={"10px 32px"}
              borderRadius={"6px"}
              cursor={"pointer"}
              onClick={() => {
                select(MartianWalletName);
              }}
            >
              <Flex bg={"light"} borderRadius={"8px"} justifyCenter alignCenter aspectRatio={"1"} width={"52px"}>
                <Image src={require("assets/image/wallet/martian.jpg")} width={"36px"} />
              </Flex>
              <Flex ml={["32px", "32px", "48px", "64px"]} color={"white"} fontWeight={"600"} fontSize={"28px"} lineHeight={"100%"}>
                Martian Wallet
              </Flex>
            </Flex>
          </Flex>
          <NormalBtn
            mt={["30px", "30px", "40px", "50px"]}
            mr={"auto"}
            background={"none"}
            gridGap={"4px"}
            p={"7px 16px"}
            onClick={() => navigate(-1)}
          >
            <ArrowIcon />
            Go Back to Home
          </NormalBtn>
        </Flex>
      </Container>
    </ContainerFluid>
  );
};

export default WalletConnectPage;
